import { render, staticRenderFns } from "./CaseIVs.vue?vue&type=template&id=dcd4b794&scoped=true&"
import script from "./CaseIVs.vue?vue&type=script&lang=js&"
export * from "./CaseIVs.vue?vue&type=script&lang=js&"
import style0 from "./CaseIVs.vue?vue&type=style&index=0&id=dcd4b794&scoped=true&lang=css&"
import style1 from "./CaseIVs.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcd4b794",
  null
  
)

export default component.exports